module.exports = __webpack_public_path__ + "img/back_30.80759cfc.svg";